<template>
  <section class="mod_lists">
    <div class="mod_figures mod_figures_v">
        <VIPNewMovie :title="'VIP专享大片'"/>
    </div>
  </section>

</template>

<script>
import VIPNewMovie from '@tencent/vft-component/Movie/VIPNewMovie'

export default {
  data () {
    return {

    }
  },
  components: {
    VIPNewMovie
  }
}
</script>

<style>
.page_skin_01 .mod_title .title{color: #fff !important}
.page_skin_01 .mod_title .icon_right{color: #b8b8b8 !important}
.page_skin_01 .upcoming_item .movie_name{color: #8d8d8d !important}
.page_skin_02 .mod_title .title{color: #474541 !important}
.page_skin_02 .mod_title .icon_right{color: #a0a0a0 !important}
.page_skin_02 .upcoming_item .movie_name{color: #474541 !important}
.page_skin_03 .mod_title .title{color: #474541 !important}
.page_skin_03 .mod_title .icon_right{color: #8d7c65 !important}
.page_skin_03 .upcoming_item .movie_name{color: #474541 !important}
.page_skin_04 .mod_title .title{color: #ac6b2b !important}
.page_skin_04 .mod_title .icon_right{color: #8d7c65 !important}
.page_skin_04 .upcoming_item .movie_name{color: #474541 !important}
.page_skin_05 .mod_title .title{color: #bf954b !important}
.page_skin_05 .mod_title .icon_right{color: #a0a0a0 !important}
.page_skin_05 .upcoming_item .movie_name{color: #979797 !important}
</style>
